<template>
    <div class="tw-container tw-mx-auto tw-mt-5">
        <template v-if="profile && !error">
            <div class="flex-1 mobile-no-padding">
                <profile-header @emitTabChange="emitTabChange" :active_tab="active_tab" :profile="profile"
                                :own_profile="ownProfile"></profile-header>

                <div class="tw-flex tw-flex-col lg:tw-flex-row">
                    <div class="tw-order-2 md:tw-order-1" style="flex:1;">

                        <profile-card v-if="profile" icon="tv" :title="$t('lesson.learning')">
                            <currently-learning :profile="profile"></currently-learning>
                        </profile-card>

                    </div>
                    <div class="lg:tw-mx-6 tw-order-1 md:tw-order-2" style="flex:3;">

                        <profile-card v-if="active_tab === 'about'" icon="hashtag" :title="$t('fields.about_me')"
                                      :profile="profile">
                            <p v-if="profile.profile.description" v-html="profile.profile.description"></p>
                            <p v-else class="tw-text-gray-400">{{ $t('profile.no_bio') }}</p>
                            <div
                                class="tw-mt-6 tw-pt-4 tw-m-auto tw-text-center tw-w-full tw-border-t tw-border-gray-200 tw-flex tw-items-center tw-justify-center">
                                <a v-if="profile.profile.facebook" :href="getSocialLink(profile.profile.facebook)"
                                   target="_blank" data-original-title="Facebook">
                                    <i aria-hidden="true"
                                       class="fab fa-facebook-square tw-text-4xl tw-mr-4 hover:tw-cursor-pointer tw-transform tw-transition  hover:tw-scale-110"
                                       style="color: #3b5998;"></i>
                                </a>
                                <a v-if="profile.profile.twitter" :href="getSocialLink(profile.profile.twitter)"
                                   target="_blank" data-original-title="twitter">
                                    <i aria-hidden="true"
                                       class="fab fa-twitter tw-text-4xl tw-mr-4 hover:tw-cursor-pointer tw-transform tw-transition  hover:tw-scale-110"
                                       style="color: #55acee;"></i>
                                </a>
                                <a v-if="profile.profile.linkedin" :href="getSocialLink(profile.profile.linkedin)"
                                   target="_blank" data-original-title="linkedin">
                                    <i aria-hidden="true"
                                       class="fab fa-linkedin tw-text-4xl tw-mr-4 hover:tw-cursor-pointer tw-transform tw-transition  hover:tw-scale-110"
                                       style="color: #007bb5;"></i>
                                </a>
                                <a v-if="profile.profile.pinterest" :href="getSocialLink(profile.profile.pinterest)"
                                   target="_blank" data-original-title="pinterest">
                                    <i aria-hidden="true"
                                       class="fab fa-pinterest tw-text-4xl tw-mr-4 hover:tw-cursor-pointer tw-transform tw-transition  hover:tw-scale-110"
                                       style="color: #ff0000;"></i>
                                </a>
                                <a v-if="profile.profile.instagram" :href="getSocialLink(profile.profile.instagram)"
                                   target="_blank" data-original-title="instagram">
                                    <i aria-hidden="true"
                                       class="fab fa-instagram tw-text-4xl tw-mr-4 hover:tw-cursor-pointer tw-transform tw-transition  hover:tw-scale-110"
                                       style="color: #e95950;"></i>
                                </a>
                                <a v-if="profile.profile.website" :href="getSocialLink(profile.profile.website)"
                                   target="_blank" data-original-title="website">
                                    <i aria-hidden="true"
                                       class="far fa-link tw-text-4xl tw-mr-4 hover:tw-cursor-pointer tw-transform tw-transition  hover:tw-scale-110 secondary-c"
                                       style="font-size: 20px;"></i>
                                </a>
                            </div>
                        </profile-card>

                        <profile-card v-if="active_tab === 'followers'" icon="user" :title="$t('profile.follower')"
                                      :profile="profile">
                            <follow-list :profile="profile" type="followers"></follow-list>
                        </profile-card>
                        <profile-card v-if="active_tab === 'following'" icon="user" :title="$t('profile.following')"
                                      :profile="profile">
                            <follow-list :profile="profile" type="following"></follow-list>
                        </profile-card>

                        <div v-if="active_tab === 'feed'">
                            <portal-target name="modal" slim></portal-target>
                            <feed custom-source="true" :user-id="profile.id"></feed>
                        </div>
                        <profile-card v-if="active_tab === 'trophies'" icon="trophy" title="Trophies" :profile="profile">
                            <div v-if="achievedTrophies.length > 0" class="tw-grid tw-grid-cols-4">
                                <trophy v-for="trophy in achievedTrophies" :key="trophy.id"
                                        class="tw-text-center tw-items-center tw-justify-center tw-my-3 tw-flex tw-flex-col"
                                        size="90" :displayOnly="true" :trophy="trophy" :showTitle="true" :showDesc="true"
                                        orientation="vertical" view="profile" :showTooltip="false">
                                </trophy>
                            </div>
                            <p v-else class="tw-text-gray-400">{{ $t('profile.no_trophies') }}</p>
                            <template v-slot:card-top v-if="ownProfile">
                                <a href="/trophies" class="secondary-c secondary-c-hover tw-block tw-float-right tw-mt-2">{{
                                        $t('membership.view_my_progress')
                                    }} &raquo;</a>
                            </template>
                        </profile-card>

                        <profile-card v-if="active_tab === 'groups'" icon="users" :title="$t('groups.user_groups')"
                                      :profile="profile">
                            <group-list :profile="profile"></group-list>
                        </profile-card>

                        <profile-card v-if="active_tab === 'certificates'" icon="file-certificate"
                                      :title="$t('profile.certificates')" :profile="profile">
                            <certificate-list :profile="profile"></certificate-list>
                        </profile-card>

                    </div>
                    <div class="tw-order-3" style="flex:1;">
                        <profile-card icon="chart-pie-alt" :title="$t('profile.user_statistics')">
                            <profile-statistic :label="$t('fields.active_since')" :value="active_since"></profile-statistic>
                            <profile-statistic :label="$t('profile.last_activity')" :value="last_activity"
                                               v-if="last_activity"></profile-statistic>
                            <profile-statistic :label="$t('profile.topics')" :value="profile.topics"></profile-statistic>
                            <profile-statistic :label="$t('profile.answers')" :value="profile.answers"></profile-statistic>
                            <profile-statistic label="Likes" :value="profile.likes"></profile-statistic>
                        </profile-card>
                    </div>
                </div>
            </div>
        </template>
        <div v-else-if="error" class="tw-flex tw-justify-center">
            <div class="card card-shadow tw-max-w-[500px]">
                <div class="card-inner tw-flex tw-items-center">
                    <i class="far fa-exclamation-triangle tw-text-orange-500 tw-mr-2" />
                    <p>{{ $t('profile.cant_view_hidden', [['username', username]]) }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../../components/profile/Header.vue';
import About from '../../components/profile/About.vue';
import Card from '../../components/profile/card/Card.vue';
import Statistic from '../../components/profile/card/Statistic.vue';
import Global from '../../mixins/Global';
import Trophy from '../../mixins/v2/Trophy';
import CurrentlyLearning from '../../components/profile/CurrentlyLearning.vue';
import FollowList from '../../components/profile/FollowList.vue';
import GroupList from '../../components/profile/GroupList.vue';
import CertificateList from '../../components/profile/CertificateList.vue';

export default {
    name: 'Profile',
    mixins: [Global, Trophy],
    components: {
        'profile-header': Header,
        'profile-about': About,
        'profile-card': Card,
        'profile-statistic': Statistic,
        'currently-learning': CurrentlyLearning,
        'follow-list': FollowList,
        'group-list': GroupList,
	    'certificate-list': CertificateList,
    },
    data() {
        return {
            username: '',
            active_tab: 'about',
            error: false,
        }
    },
    watch: {
        active_tab(newVal) {
            if (newVal) {
                this.setProfileTabUrl(newVal);
            }
        }
    },
    computed: {
        active_since() {
            return moment(this.profile.created_at).format('DD/MM/YYYY');
        },
        last_activity() {
            return this.profile.last_activity ? moment(this.profile.last_activity).format('DD/MM/YYYY') : null;
        },
        profile() {
            if (this.username) {
                return HuddleUser.query().where('username', this.username).get()[0];
            } else {
                // no username, so fetch own user
                return HuddleUser.find(this.user.id);
            }

        },
        ownProfile() {
            return this.user && this.profile && this.user.id === this.profile.id;
        }
    },
    methods: {
        getProfile() {
            if (this.username) {
                HuddleUser.api().findByUsername(this.username)
                    .then(() => {
                        this.error = false;
                    })
                    .catch(() => {
                        this.error = true;
                    });
            } else {
                // no username, so fetch own user
                HuddleUser.api().me();
            }
        },
        emitTabChange(val) {
            this.active_tab = val;
        },
        getSocialLink(url) {
            return this.getValidUrl(url, true);
        },
        setProfileTabUrl(tab) {
            const url_params = new URLSearchParams();
            url_params.set('tab', tab);
            window.history.replaceState({}, '', `${window.location.pathname}?${url_params}`);
        }
    },
    mounted() {
        this.getProfile();
    },
    // check url which screen we are showing
    beforeRouteUpdate(to, from, next) {
        next(vm => {
            vm.username = to.params.username;
        });
    },
    // check url which screen we are showing
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.username = to.params.username;
            if (to.query.tab) {
                vm.active_tab = to.query.tab;
            } else {
                vm.setProfileTabUrl(vm.active_tab);
            }
        });
    },
}
</script>

<style lang="scss" scoped>
.tw-container {
    margin: 20px auto;
    padding-left: 20px;
    padding-right: 20px;
}

@media (min-width: 1300px) {
    .tw-container {
        max-width: 1440px;
    }
}
</style> 
